<template>
  <div class="w-100">
    <div class="d-flex align-items-center mb-2">
      <h5 class="mb-0">سوال {{ questionIndex + 1 }}</h5>

      <feather-icon
        v-if="!isUpdating"
        @click="removeQuestionFromList"
        icon="Trash2Icon"
        size="20"
        class="text-danger cursor-pointer ml-1"
      />
    </div>
    <b-form-group
      label="سوال نظرسنجی"
      :label-for="`questionTitle-${questionIndex}`"
    >
      <b-form-input
        v-model="questionDetails.questionTitle"
        :id="`questionTitle-${questionIndex}`"
        trim
        placeholder="نحوه تدریس استاد"
      />
    </b-form-group>
    <hr class="my-2" />
    <div class="d-flex align-items-center mb-2">
      <h5 class="mb-0">جواب های سوال {{ questionIndex + 1 }}</h5>
      <feather-icon
        v-if="!isUpdating"
        @click="addMoreAnswersToQuestion"
        icon="PlusCircleIcon"
        class="text-success cursor-pointer ml-1"
        size="20"
      />
    </div>
    <template
      v-if="questionDetails.responses && questionDetails.responses.length > 0"
    >
      <div v-for="(response, index) in questionDetails.responses">
        <b-form-group
          :label="`متن جواب ${index + 1}`"
          :label-for="`response-${index}`"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              v-model="response.answer"
              :id="`response-${index}`"
              trim
              placeholder="عالی"
            />
            <b-input-group-append is-text>
              <feather-icon
                v-if="!isUpdating"
                @click="removeAnswerFromQuestion(index)"
                class="cursor-pointer text-danger"
                icon="XIcon"
                size="18"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group
          :label="`نمره جواب ${index + 1}`"
          :label-for="`response-${index}`"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              v-model="response.answerValue"
              :id="`response-${index}`"
              trim
              placeholder="نمره جواب"
            />
          </b-input-group>
        </b-form-group>
        <!-- answerValue -->
      </div>
    </template>
    <template v-else>
      <p class="text-center">هنوز هیچ جوابی اضافه نکرده‌اید!</p>
    </template>
  </div>
</template>
<script>
export default {
  emits: [
    "removeQuestionFromList",
    "addAnswerToQuestion",
    "removeAnswerFromQuestion",
  ],
  props: {
    questionDetails: {
      type: Object,
      required: true,
    },
    questionIndex: {
      type: [String, Number],
      required: true,
    },
    isUpdating: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    removeAnswerFromQuestion(answerIndex) {
      this.$emit("removeAnswerFromQuestion", this.questionIndex, answerIndex);
    },
    addMoreAnswersToQuestion() {
      this.$emit("addAnswerToQuestion", this.questionIndex);
    },
    removeQuestionFromList() {
      this.$emit("removeQuestionFromList", this.questionIndex);
    },
  },
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
};
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
</script>
